// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OtherElements_wrapper__VZh7i"};